import React from 'react';
const ITEMS = [
  '🛒 POS Billing','📦 Inventory Sync','🚚 Delivery Integration','👥 Customer App','🏍 Porter App',
  '📊 Sales Analytics','🏪 Multi-Store','💳 Payment Modes','📋 Vendor Management','🔁 Refund Support',
  '📣 Promotions','⏰ Business Hours','📦 Bulk Orders','🎉 Offers Management','🔔 Low Stock Alerts',
  '🛒 POS Billing','📦 Inventory Sync','🚚 Delivery Integration','👥 Customer App','🏍 Porter App',
  '📊 Sales Analytics','🏪 Multi-Store','💳 Payment Modes','📋 Vendor Management','🔁 Refund Support',
  '📣 Promotions','⏰ Business Hours','📦 Bulk Orders','🎉 Offers Management','🔔 Low Stock Alerts',
];
export default function TrustBar() {
  return (
    <section style={{ background: 'white', borderTop: '1px solid #e5e7eb', borderBottom: '1px solid #e5e7eb', padding: '16px 0' }}>
      <div className="ticker-wrap">
        <div className="ticker-track">
          {ITEMS.map((item, i) => (
            <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 28, padding: '0 28px', whiteSpace: 'nowrap' }}>
              <span style={{ fontSize: 13, fontWeight: 600, color: '#4b5563' }}>{item}</span>
              <span style={{ width: 4, height: 4, borderRadius: '50%', background: '#d1d5db', flexShrink: 0 }} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
